import { global_hooks } from 'src/globals';
import Dropdown from 'components/ui/dropdown/Dropdown';

global_hooks.on('init', init);

function init() {
	if (window.innerWidth > 768) return;
	document
		.querySelectorAll('.tabs_mobile_dropdown')
		.forEach(init_tabs_dropdown);
}

function init_tabs_dropdown(el) {
	const headings_con = el.querySelector('.e-n-tabs-heading');
	if (!headings_con) return;
	headings_con.style.display = 'none';

	const con = document.createElement('div');
	con.className = 'tabs_dropdown';
	headings_con.before(con);

	const select = document.createElement('select');
	con.append(select);

	const tabs_buttons = headings_con.querySelectorAll('.e-n-tab-title');

	tabs_buttons.forEach((btn, i) => {
		const option = document.createElement('option');
		option.text = btn.textContent.trim();
		option.value = i;
		if (btn.getAttribute('aria-selected') === 'true') option.selected = true;
		select.append(option);
	});

	// Apply the styled custom dropdown design
	const dropdown = new Dropdown(select);

	dropdown.hooks.on('select', (option) => {
		const i = parseInt(option.value, 10);
		tabs_buttons[i]?.click();
	});
}
